import RetailerOrder from './RetailerOrder'

export default RetailerOrder
